// extracted by mini-css-extract-plugin
export default {"ExpirationBadge":"ExpirationBadge_ExpirationBadge__ivRJx"};